module.exports = __webpack_public_path__ + "img/img43.c8ec755c.svg";